import { getSnippet } from "./api";

function appendHtml(container, html) {
  const range = document.createRange();
  range.setStart(container, 0);
  range.setEnd(container, 0);
  container.appendChild(range.createContextualFragment(html));
}

class BonussammelnLoader extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector("div");
  }

  connectedCallback() {
    this.loadSnippet();
  }

  async loadSnippet() {
    const snippet = await getSnippet(this.container.dataset.value.split("|")).then(result => result.text());
    appendHtml(this.container, snippet);
  }
}

if (!customElements.get("bonussammeln-loader")) {
  customElements.define("bonussammeln-loader", BonussammelnLoader);
}
